"use client";

import { useState } from "react";

/** Runs a request of a settings window: busy meanwhile, its error kept to show. */
export function useRequest() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = async (request: () => Promise<void>) => {
    setBusy(true);
    setError(null);
    await request()
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)))
      .finally(() => setBusy(false));
  };
  return { busy, error, run };
}
